<template>
  <div>
    <v-container fluid style="background-color: #4b2a66">
      <v-row justify="center"
        ><v-col cols="10">
          <v-row align="center">
            <v-col
              cols="12"
              md="6"
              lg="6"
              xl="6"
              class="white--text"
              :class="{
                'text-center': $vuetify.breakpoint.smAndDown,
                'text-end': $vuetify.breakpoint.mdAndUp,
              }"
            >
              <div
                class="d-flex flex-column justify-space-between"
                :class="{
                  'align-center': $vuetify.breakpoint.smAndDown,
                  'align-end': $vuetify.breakpoint.mdAndUp,
                }"
              >
                <v-img src="/logo-white.svg" max-width="150%" />
              </div>
              <p class="font-weight-bold title1 mt-5" style="line-height: 1">
                A sua Vitrine Online. <br />É Grátis e Fácil de Usar.
              </p>
              <div class="subtitle1">
                Através do Olhadela você poderá Divulgar ou Encontrar
                Produtos/Serviços em um só lugar. Assista ao Vídeo e entenda um
                pouco mais.
              </div>
            </v-col>
            <v-col cols="12" md="6" lg="6" xl="6">
              <iframe
                width="100%"
                height="350"
                src="https://www.youtube.com/embed/r1dOQz5kHsI?autoplay=1&mute=0&enablejsapi=1"
                frameborder="0"
                allow="autoplay; fullscreen"
              ></iframe>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row align="center" justify="center" class="mt-5"
        ><v-col cols="10">
          <div
            class="mt-5 font-weight-bold title1 text-center black--text"
            style="line-height: 1"
          >
            Por que utilizar o Olhadela?
          </div>
          <v-row>
            <v-col
              cols="12"
              sm="4"
              class="text-center mt-5"
              v-for="(feature, i) in features"
              :key="i"
            >
              <v-img
                :src="feature.img"
                max-width="220px"
                class="ml-auto mr-auto"
              />

              <div
                class="title2 text-center black--text mt-2"
                style="line-height: 1"
                v-html="feature.title"
              />
            </v-col>
          </v-row>

          <div align="center" class="mt-10">
            <v-btn
              x-large
              dark
              :class="{
                title2: $vuetify.breakpoint.mdAndUp,
              }"
              class="elevation-5"
              style="background-color: #4b2a66"
              @click="(formDialog.active = true), (type = 1)"
            >
              <template v-if="!$vuetify.breakpoint.mobile">
                Clique aqui e Cadastre AGORA o seu Negócio!
              </template>
              <template v-else> Cadastrar meu negócio! </template>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="mt-5 grey lighten-4">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <div
            class="mt-5 font-weight-bold title1 text-center black--text"
            style="line-height: 1"
          >
            5 Passos para Utilizar o seu Olhadela
          </div>

          <v-row class="mt-5">
            <v-col
              cols="12"
              sm="6"
              class="mt-5"
              v-for="(card, i) in cards"
              :key="i"
            >
              <v-card elevation="8" height="100%" class="d-flex flex-column">
                <v-card-title primary-title class="break title2">{{
                  card.title
                }}</v-card-title>

                <v-card-text
                  class="break text--primary font-weight-regular subtitle-1"
                  v-html="card.text"
                />
                <v-spacer />
                <v-card-actions class="pt-0">
                  <v-btn
                    large
                    dark
                    block
                    style="background-color: #4b2a66"
                    @click="(formDialog.active = true), (type = card.type)"
                  >
                    <template v-if="!$vuetify.breakpoint.mobile">
                      <div v-html="card.btn" />
                    </template>
                    <template v-else>
                      <div v-html="card.btnMobile" />
                    </template>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="mt-5">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <div
            class="font-weight-bold title1 text-center black--text"
            style="line-height: 1"
          >
            Perguntas Frequentes
          </div>
          <v-row class="mt-5">
            <v-col cols="12" md="12" lg="12" xl="12">
              <CommonQuestions />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="background-color: #4b2a66">
      <v-row align="center" justify="center" class="mt-5">
        <v-col cols="10">
          <v-row>
            <v-col
              cols="12"
              sm="6"
              :class="{
                'text-center': $vuetify.breakpoint.smAndDown,
                'text-end': $vuetify.breakpoint.mdAndUp,
              }"
            >
              <div
                class="font-weight-bold title1 white--text"
                style="line-height: 1"
              >
                Caso tenha alguma dúvida<br />
                ou queira contatar nossa equipe,<br />
                selecione a opção que desejar:
              </div>
            </v-col>
            <v-col cols="12" sm="6" align="start">
              <div class="my-2" v-for="(icon, i) in icons" :key="i">
                <v-btn
                  large
                  block
                  :href="icon.link"
                  target="_blank"
                  color="white"
                  class="purple--text elevation-10"
                >
                  <v-icon class="purple--text" left>{{ icon.icon }}</v-icon>
                  {{ icon.text }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="mt-5 white--text" align="center">
        Siga nossas Redes Sociais:
        <v-btn
          dark
          icon
          href="https://www.facebook.com/olhadela.digital"
          target="_blank"
        >
          <v-icon :size="$vuetify.breakpoint.xs ? '20px' : '24px'"
            >mdi-facebook</v-icon
          >
        </v-btn>
        <v-btn
          dark
          icon
          href="https://instagram.com/olhadela.digital"
          target="_blank"
        >
          <v-icon :size="$vuetify.breakpoint.xs ? '20px' : '24px'"
            >mdi-instagram</v-icon
          >
        </v-btn>
      </div>
    </v-container>

    <v-dialog
      v-model="formDialog.active"
      max-width="500px"
      :persistent="formDialog.loading"
    >
      <v-card class="pa-4">
        <v-card-title
          class="
            text-h5
            break
            d-flex
            justify-center
            text-center
            font-weight-bold
          "
        >
          <template v-if="type == 1"> Cadastrar Negócio </template>
          <template v-else>Lista de Espera </template>
        </v-card-title>
        <v-card-title class="break subtitle1 justify-center text-center">
          <div>Informe seus dados para prosseguir com o cadastro.</div>
        </v-card-title>
        <v-card-text>
          <v-form ref="leadsForm">
            <v-text-field
              label="Nome *"
              v-model="formDialog.data.name"
              dense
              :rules="[$rules.required]"
              :disabled="formDialog.loading"
            />
            <v-text-field
              label="E-mail *"
              v-model="formDialog.data.email"
              dense
              class="mt-5"
              :rules="[$rules.required, $rules.email]"
              :disabled="formDialog.loading"
            />
            <v-text-field
              v-if="type == 2"
              label="Cidade *"
              v-model="formDialog.data.city"
              dense
              class="mt-5"
              :rules="[$rules.required]"
              :disabled="formDialog.loading"
            />
          </v-form>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-btn
            dark
            block
            style="background-color: #4b2a66"
            :loading="formDialog.loading"
            @click="type == 1 ? newRegister() : newList()"
          >
            <template v-if="type == 1"> Iniciar Meu Cadastro</template>
            <template v-else>Entrar na Fila </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/layout/default/Footer.vue";
import CommonQuestions from "@/components/CommonQuestions.vue";

export default {
  name: "Landing",
  components: {
    CommonQuestions,
    Footer,
  },
  data() {
    return {
      type: undefined,
      formDialog: {
        active: false,
        loading: false,
        data: {
          name: "",
          email: "",
          city: "",
        },
      },

      cards: [
        {
          title: "Como Cadastrar o meu Negócio?",
          text: "1º Faça seu Login ou Cadastre-se;<br/>2º Clique em “CRIE SEU NEGÓCIO”;<br/>3º Assista ao Vídeo e siga o Passo a Passo;<br/>4ºCadastre seus Produtos/Serviços;<br/>5º Divulge sua Página e Aumente suas Vendas.",
          btn: "Cadastrar meu negócio",
          btnMobile: "Cadastrar meu negócio",
          type: 1,
        },
        {
          title: "Como Encontrar Produtos ou Serviços?",
          text: "1º Acesse nosso Site;<br/>2º Informe sua Localização;<br/>3º Nos diga o que está Procurando;<br/>4º Selecione o Produto/Serviço;<br/>5º Entre em Contato para mais Informações.",
          btn: "Faça parte da lista de espera",
          btnMobile: "Lista de espera",
          type: 2,
        },
      ],
      icons: [
        {
          text: "Enviar e-mail",
          icon: "mdi-email",
          link: "mailto: contato@olhadela.digital",
        },
        {
          text: "Conversar via Whatsapp",
          icon: "mdi-whatsapp",
          link: "https://wa.me/554930030944",
        },
      ],
      features: [
        {
          img: require("@/assets/showcase.png"),
          title:
            "Uma Vitrine Online<br/> de Fácil utilização e<br/> na palma da sua mão.",
        },
        {
          img: require("@/assets/localization.png"),
          title:
            "Busca por<br/> Produtos/Serviços com<br/> base na sua Localização.",
        },
        {
          img: require("@/assets/unlimited.png"),
          title: "É Grátis.<br/>Sem Limite de Cadastros.<br/>É para você!",
        },
      ],
    };
  },
  methods: {
    newRegister() {
      if (this.$refs.leadsForm.validate()) {
        this.formDialog.loading = true;
        const queryParams = Object.entries(this.$route.query).map(
          ([key, val]) => `${key}=${val}`
        );
        this.$axios
          .post("/new-lead", {
            ...this.formDialog.data,
            tags: ["LP Olhadela", "Empresa", ...queryParams],
          })
          .then(() => {
            this.$router.push({
              path:
                "/cadastro/" +
                this.formDialog.data.name +
                "/" +
                this.formDialog.data.email,
            });
            this.$refs.leadsForm.reset();
            this.formDialog.active = false;
          })
          .catch(() => {
            this.$showMessage(
              "error",
              "Ocorreu um erro inesperado. Por favor, contate nosso suporte em contato@olhadela.digital"
            );
          })
          .finally(() => {
            this.formDialog.loading = false;
          });
      } else {
        this.$showMessage(
          "warning",
          "Por favor, preencha os campos obrigatórios"
        );
      }
    },
    newList() {
      if (this.$refs.leadsForm.validate()) {
        this.formDialog.loading = true;
        const queryParams = Object.entries(this.$route.query).map(
          ([key, val]) => `${key}=${val}`
        );
        this.$axios
          .post("/new-lead", {
            ...this.formDialog.data,
            tags: ["LP Olhadela", "Lista de Espera", ...queryParams],
          })
          .then(() => {
            this.$showSuccessMessage(
              "Agradecemos pelo seu Contato e Interesse.",
              "Enviaremos ao seu e-mail, periodicamente: Atualidades, Dicas, Informações e muito mais sobre o Olhadela. Fique atento!"
            );
            this.$refs.leadsForm.reset();
            this.formDialog.active = false;
          })
          .catch(() => {
            this.$showMessage(
              "error",
              "Ocorreu um erro inesperado. Por favor, contate nosso suporte em contato@olhadela.digital"
            );
          })
          .finally(() => {
            this.formDialog.loading = false;
          });
      } else {
        this.$showMessage(
          "warning",
          "Por favor, preencha os campos obrigatórios"
        );
      }
    },
  },
};
</script>


<style scoped>
.break {
  word-break: break-word;
}
.title1 {
  font-size: 34px;
  font-weight: bold;
}
.title2 {
  font-size: 28px;
}
.subtitle1 {
  font-size: 21px;
}
</style>
